import React from 'react'

/** 検証エラー用（モックアップ: 淡い赤丸 + !） */
export const ErrorIcon = ({ className = '' }) => (
  <span
    className={`inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-[#fecaca] bg-[#fee2e2] text-xs font-bold text-[#dc2626] ${className}`}
    aria-hidden
  >
    !
  </span>
)

/** 検証警告用（モックアップ: 淡い黄丸 + ?） */
export const WarningIcon = ({ className = '' }) => (
  <span
    className={`inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-[#fde047] bg-[#fef9c3] text-xs font-bold text-[#ca8a04] ${className}`}
    aria-hidden
  >
    ?
  </span>
)

/**
 * マッピング結果テーブル用ホバー表示文字列
 *
 * @param {{
 *   isError: boolean
 *   isWarning: boolean
 *   isEmpty: boolean
 *   rawValue: unknown
 * }} p
 * @returns {string}
 */
export function getValidationMappingCellTitle({ isError, isWarning, isEmpty, rawValue }) {
  const valuePart = isEmpty ? '(未入力) 空値' : String(rawValue)
  if (isError) return `エラー(取込不可) ${valuePart}`
  if (isWarning) return `警告(確認推奨) ${valuePart}`
  return valuePart
}

/** マッピング結果CSV / マッピング結果テーブル下の凡例 */
export const ValidationMappingLegend = () => (
  <div className="mt-2 px-4 pb-3">
    <div className="flex flex-wrap items-center gap-6 rounded border border-[#cbd5e1] bg-[#f8fafc] px-4 py-2.5 text-sm text-[#334155]">
      <span className="inline-flex items-center gap-2">
        <ErrorIcon />
        <span>エラー(取込不可)</span>
      </span>
      <span className="inline-flex items-center gap-2">
        <WarningIcon />
        <span>警告(確認推奨)</span>
      </span>
      <span className="italic text-[#94a3b8]">(未入力) 空値</span>
    </div>
  </div>
)
